import { BUSINESS, SITE_URL } from "../../../data/site"
import { LOCAL_BUSINESS_ID } from "./localBusiness"

type ServiceArgs = {
  name: string
  description: string
  url: string
  serviceType?: string
  areaServed?: string[]
}

export const buildService = ({
  name,
  description,
  url,
  serviceType,
  areaServed,
}: ServiceArgs) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  name,
  description,
  url: `${SITE_URL}${url}`,
  serviceType: serviceType || name,
  provider: { "@id": LOCAL_BUSINESS_ID },
  areaServed: (areaServed || BUSINESS.areaServed).map((a) => ({
    "@type": "Place",
    name: a,
  })),
})
